// Copyright (c) Docugami, Inc. All rights reserved.

import { OAuthRequestStatus, Token } from "./Authentication";

export enum ProviderId {
    SharePoint = 'SharePoint',
    OneDrive = 'OneDrive',
    Box = 'Box',
    Dropbox = 'Dropbox',
    OAuth = 'OAuth'
}

export enum ProviderAuthenticationId
{
    MicrosoftGraph = 'MicrosoftGraph',
    Box = 'Box',
    Dropbox = 'Dropbox',
    OAuth = 'OAuth'
}

export interface StorageProviderTokenRequest {
    providerId: ProviderId;
    oauthProviderId?: string;
}

export interface StorageProviderAuthenticationResponse {
    status: OAuthRequestStatus;
    accessToken?: Token;
}

export interface UploadItemDetails {
    item: ProviderItem;
    isSynced: boolean;
}

export interface UploadDocumentsRequest {
    providerId: ProviderId;
    items: UploadItemDetails[];
    docSetId?: string;
}

export enum UploadStatus {
    GatheringFiles = 'GatheringFiles',
    Uploading = 'Uploading',
    Complete = 'Complete',
    Failed = 'Failed'
}

export interface UploadDocumentsStatus {
    requestId: string;
    providerId: ProviderId;
    status: UploadStatus;
    totalCount: number;
    failedCount: number;
    succeededCount: number;
    timeStamp: Date;
    results?: DocumentUploadResult[];
}

export interface DocumentUploadResult {
    succeeded: boolean;
    filePath: string;
}

export type BoxItemId = string;

export enum BoxItemType {
    File,
    Folder
}

export interface BoxItem {
    id: BoxItemId;
    type: BoxItemType;
}

export type DropboxItemId = string;

export interface DropboxItem {
    id: DropboxItemId;
}

export interface GraphItem {
    id: GraphItemId;
}

export interface GraphItemId {
    itemId: string;
    driveId: string;
}

export type ProviderItem = GraphItem | BoxItem | DropboxItem;
export type ProviderItemId = GraphItemId | BoxItemId | DropboxItemId;

export function compare(item1: ProviderItem, item2: ProviderItem, providerId: ProviderId) {
    if (providerId === ProviderId.OneDrive || providerId === ProviderId.SharePoint) {
        const graph1 = item1 as GraphItem;
        const graph2 = item2 as GraphItem;
        return graph1.id.driveId === graph2.id.driveId && graph1.id.itemId === graph2.id.itemId;
    }
    else if (providerId === ProviderId.Box) {
        const box1 = item1 as BoxItem;
        const box2 = item2 as BoxItem;
        return box1.id === box2.id && box1.type === box2.type;
    }
    else if (providerId === ProviderId.Dropbox) {
        return item1.id === item2.id;
    }

    return false;
}
